import { Theme } from "@mui/material"

import {
    ListItemButton as UiListItemButton,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

const containerStyle = (theme: Theme) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    padding: theme.spacing(2, 0),
    width: "100%",
})

export const ListItemButton = styled(UiListItemButton)(({ theme }) => containerStyle(theme))

export const ListItemContainer = styled("div")(({ theme }) => containerStyle(theme))

type ListItemProps = {
    variant: "primary" | "secondary"
}

export const ListItem = styled("div", { shouldForwardProp: prop => prop !== "variant" })<ListItemProps>(({ theme, variant }) => ({
    alignItems: "start",
    justifyContent: "center",
    display: "flex",
    flex: 1,
    flexDirection: "column",
    gap: variant === "primary" ? 0 : theme.spacing(1),
    height: "100%",
    padding: theme.spacing(2, 0, 2, 0),
}))

export const ListItemHeader = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    height: "30px",
    justifyContent: "start",
    width: "100%",
}))

export const PrimaryTypography = styled(Typography)(({ theme }) => ({
    color: theme.palette["common/black_states"].main,
}))

type StyledSecondaryTypographyProps = {
    textColor: "primary" | "text/secondary" | "text/tertiary"
}

export const SecondaryTypography = styled(Typography, { shouldForwardProp: prop => prop !== "textColor" })<StyledSecondaryTypographyProps>(({ theme, textColor }) => ({
    color: theme.palette[textColor].main,
}))

export const Badge = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["info"].light,
    borderRadius: 1000,
    marginLeft: "auto",
    width: 32,
    height: 32,
    color: theme.palette["text/primary"].main,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
}))

export const Wrapper = styled("div")({
})

export const IconWrapper = styled("div")(({ theme }) => ({
    flexDirection: "column",
    justifyContent: "space-evenly",
    alignItems: "center",
    display: "flex",
    height: "100%",
    marginRight: theme.spacing(8),
}))